import environment from '@environments/environment';

let oneTrustLoaded = false;

export function loadOneTrust() {
  if (oneTrustLoaded || !environment?.oneTrustDomainScript?.length) return;

  const script = document.createElement('script');
  script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.setAttribute('data-domain-script', environment.oneTrustDomainScript);

  script.onload = () => {
    oneTrustLoaded = true;
    const optanonWrapperScript = document.createElement('script');
    optanonWrapperScript.type = 'text/javascript';
    optanonWrapperScript.text = 'function OptanonWrapper() {}';
    document.head.appendChild(optanonWrapperScript);
  };

  script.onerror = (error) => {
    console.warn('Failed to load OneTrust script:', error);
  };

  document.head.appendChild(script);
}
